export const getOffsetX = (event: React.MouseEvent | React.TouchEvent) => {
  if (
    'touches' in event.nativeEvent &&
    event.nativeEvent.target instanceof HTMLElement
  ) {
    const touch = event.nativeEvent.touches[0]
    const target = event.nativeEvent.target
    const targetClientX = target.getBoundingClientRect().left
    return touch.clientX - targetClientX
  }

  if ('offsetX' in event.nativeEvent) {
    return event.nativeEvent.offsetX
  }

  return 0
}
